export default __webpack_public_path__ + "static/media/logo.b3e842eb.svg";